import { getAllConfigurationData, getKeyId, getMerchantId, getP12Key, getSecretKey } from "../lhs/reducers/configuration-reducer";

function setCredCookie(cname, cvalue) {
    if (cname == "access_token") {
        /*var now = new Date();
        var date = new Date(now.getTime() + $scope.accessToken_time * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";" + ";path=/" + "; " + "SameSite=strict";*/
    } else if (cname == "refresh_token") {
        /*var now = new Date();
        var date = new Date(now.getTime() + $scope.refreshToken_time * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";" + ";path=/" + "; " + "SameSite=strict";*/
    } else {
        document.cookie = cname + "=" + cvalue + "; " + "SameSite=strict";
    }
}

function getCredCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0){
          return c.substring(name.length, c.length);
        } 
    }
    return null;
}

// check if its default http signature merchant id 
function isDefaultHTTPMerchantId()
{
  var defaultMerchantId = getMerchantId();
  var httpMerchantId = getCredCookie("merchantId");
  if(httpMerchantId == defaultMerchantId)
  {
    return true;
  }
  return false;
}

// check if its a default jwt merchant id
function isDefaultJWTMerchantId()
{
  var defaultMerchantId = getMerchantId();
  var httpMerchantId = getCredCookie("jwtMerchantId");
  if(httpMerchantId == defaultMerchantId)
  {
    return true;
  }
  return false;
}

function getMerchantDetails(merchantId){ 
  const merchantCreds = getAllConfigurationData();
  var index;
  for (index in merchantCreds['credentials']){
    if(merchantCreds['credentials'][index]["merchantId"] == merchantId){
      return merchantCreds['credentials'][index];
    }
  }
  return null;
}

function setDefaultHTTPCredsInCookies(){
  var merchantId = getMerchantId()
  var keyId = getKeyId();
  var secretKey = getSecretKey();
  setCredCookie('merchantId', merchantId);
  setCredCookie('key',keyId);
  setCredCookie('secretKey', secretKey);
}

// set http creds in cookies
function setHTTPCredsInCookies(merchantDetails){
  var merchantId = merchantDetails['merchantId'];
  var httpSignatureCreds = merchantDetails['authentication']['httpSignature'];
  var keyId = httpSignatureCreds['keyId'];
  var secretKey = httpSignatureCreds['secretKey'];
  setCredCookie('merchantId', merchantId);
  setCredCookie('key',keyId);
  setCredCookie('secretKey', secretKey);
}

// set default jwt creds in cookies
function setDefaultJWTCredsInCookies(){
  var merchantId = getMerchantId();
  var jwtKey = getP12Key();
  setCredCookie('jwtMerchantId', merchantId);
  sessionStorage.setItem('jwttoken', jwtKey);
}

// set jwt creds in cookies
function setJWTCredsInCookies(merchantDetails){
  var merchantId = merchantDetails['merchantId'];
  var jwtKey = merchantDetails['authentication']['jwt']['p12Key'];
  setCredCookie('jwtMerchantId', merchantId);
  sessionStorage.setItem('jwttoken', jwtKey);
}
// store http creds
function storeHTTPCreds(merchantId, key, secretKey){
  setCredCookie("merchantId", merchantId);
  setCredCookie("key", key);
  setCredCookie("secretKey", secretKey);
}
  
function storeJWTCreds(merchantId, p12keys){
  setCredCookie("jwtMerchantId", merchantId);
  sessionStorage.setItem('jwttoken', '');
  sessionStorage.setItem('jwttoken', p12keys);  
}

export {getCredCookie, setCredCookie, setDefaultHTTPCredsInCookies, setDefaultJWTCredsInCookies, storeHTTPCreds, storeJWTCreds,isDefaultHTTPMerchantId,isDefaultJWTMerchantId,getMerchantDetails,setHTTPCredsInCookies,setJWTCredsInCookies};
